import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/oven-icon-black.png'
import _imports_1 from '@/assets/icons/bathtub-icon-black.png'
import _imports_2 from '@/assets/icons/sofa-icon-black.png'


const _hoisted_1 = {
  key: 0,
  class: "content-browse-interiors"
}
const _hoisted_2 = { class: "content-bottons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.houseInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-browse" }, "Browse Interiors", -1)),
        _createElementVNode("div", _hoisted_2, [
          ($setup.props.houseInfo.kitchens.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["jump-button", { selected: $setup.selectedSection === $setup.BuilderSliderSteps.KITCHEN }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onSelectSection($setup.BuilderSliderSteps.KITCHEN)))
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-jump-to-button" }, "Kitchen", -1)),
                _createElementVNode("img", {
                  class: _normalizeClass(["small", { 'icon-white': $setup.selectedSection === $setup.BuilderSliderSteps.KITCHEN }]),
                  src: _imports_0
                }, null, 2)
              ], 2))
            : _createCommentVNode("", true),
          ($setup.props.houseInfo.bathroom.options.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["jump-button", { selected: $setup.selectedSection === $setup.BuilderSliderSteps.BATHROOM }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onSelectSection($setup.BuilderSliderSteps.BATHROOM)))
              }, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-jump-to-button" }, "Bathroom", -1)),
                _createElementVNode("img", {
                  class: _normalizeClass(["small", { 'icon-white': $setup.selectedSection === $setup.BuilderSliderSteps.BATHROOM }]),
                  src: _imports_1
                }, null, 2)
              ], 2))
            : _createCommentVNode("", true),
          ($setup.props.houseInfo.loungeRoom.urls.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["jump-button", { selected: $setup.selectedSection === $setup.BuilderSliderSteps.LIVING }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onSelectSection($setup.BuilderSliderSteps.LIVING)))
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-jump-to-button" }, "Living", -1)),
                _createElementVNode("img", {
                  class: _normalizeClass(["small", { 'icon-white': $setup.selectedSection === $setup.BuilderSliderSteps.LIVING }]),
                  src: _imports_2
                }, null, 2)
              ], 2))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}